import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
} from "react-router-dom";
import DashboardComponent from "./Components/Dashboard";
import "dayjs/locale/de"
import dayjs from "dayjs";

export default function Playbook() {
  dayjs.locale("de")
  return (
    <Router>
      <Switch>
        <Route exact path="/:id?">
          <Dashboard />
        </Route>
      </Switch>
    </Router>
  );
}

function Dashboard() {
  let { id } = useParams();
  
  return (
    <DashboardComponent id={id} />
  )
}
